// utils.js
import React from "react";

export const brandGradient =
  "bg-gradient-to-r from-indigo-500 via-fuchsia-500 to-amber-400";

export function classNames(...cn) {
  return cn.filter(Boolean).join(" ");
}

export function highlight(text, q) {
  if (!q) return text;
  const parts = String(text).split(new RegExp(`(${q})`, "gi"));
  return parts.map((p, i) =>
    p.toLowerCase() === q.toLowerCase() ? (
      <mark key={i} className="bg-yellow-200 dark:bg-yellow-600 px-0.5">
        {p}
      </mark>
    ) : (
      p
    )
  );
}

/**
 * getImageUrl
 * - Si `name` commence par http(s):// ou / -> retourne tel quel
 * - Sinon, préfixe avec /img/Tutoriel/
 *
 * ⚠️ Place tes images dans: public/img/Tutoriel/ (respecter la casse)
 * Dans steps.data.js, utilise des chemins ABSOLUS: "/img/Tutoriel/xxx.png"
 */
export function getImageUrl(name) {
  if (!name) return "";
  if (name.startsWith("http://") || name.startsWith("https://") || name.startsWith("/")) {
    return name;
  }
  return `/img/Tutoriel/${name}`;
}
